export enum ApplicationStatus {
  Started = "Started",
  DroppedOut = "DroppedOut",
  Referred = "Referred",
  AwaitingPersonalGuarantee = "AwaitingPersonalGuarantee",
  PersonalGuaranteeFollowUp = "PersonalGuaranteeFollowUp",
  Completed = "Completed",
  Cancelled = "Cancelled",
  Declined = "Declined",
  Approved = "Approved",
  CallbackRequested = "CallbackRequested",
  Draft = "Draft",
  CardAccountSetupComplete = "CardAccountSetupComplete",
}
